import * as Sentry from '@sentry/react';
import { FC, useRef } from 'react';

import { useAnalytics } from '@hooks/useAnalytics';
import { DynamicActionProperties, useDynamicAction } from '@hooks/useDynamicAction';

import { NavigateOptions } from '@router/index';

import Button, { ButtonProps } from './Button';

interface DynamicActionButtonProps extends Omit<ButtonProps, 'onClick'> {
  actionProperties?: DynamicActionProperties;
  navigateOptions?: NavigateOptions;
}

export const DynamicActionButton: FC<DynamicActionButtonProps> = ({
  actionProperties,
  navigateOptions,
  ...buttonProps
}) => {
  const { handleDynamicAction } = useDynamicAction();
  const isSubmittingRef = useRef(false);

  const handleClick = async () => {
    if (!isSubmittingRef.current) {
      try {
        isSubmittingRef.current = true;
        await handleDynamicAction(actionProperties, navigateOptions);
      } catch (e) {
        Sentry.captureException(e);
      } finally {
        isSubmittingRef.current = false;
      }
    }
  };

  return <Button onClick={handleClick} {...buttonProps} />;
};
